import IImportationDetails, { ImportationDetailsStatus } from "@/interfaces/importation-details";
import { ImportationDetailsFiltersMessages } from "@/messages/importationDetails/importation-details-filter.messages";
import { ImportationDetailsTableMessages } from "@/messages/importationDetails/importation-details-table.messages";
import { FilterAttributes, FilterType, FilterValue, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";

import { ImportationDetailsFilterKey } from "./types";

export const TABLE_COLUMNS = (messages: ImportationDetailsTableMessages) => {
  return [messages.codeColumn, messages.nameColumn, messages.statusColumn, messages.messageColumn];
};

export const FILTER_OPTIONS = (
  messages: ImportationDetailsFiltersMessages
): SelectData<ImportationDetailsFilterKey>[] => [
  { label: messages.allOption, value: "importProcessId" },
  { label: messages.codeOption, value: "code" },
  { label: messages.nameOption, value: "name" },
  { label: messages.statusOption, value: "status" },
  { label: messages.messageOption, value: "message" },
];

export const FILTER_ATTRIBUTES: Partial<Record<ImportationDetailsFilterKey, FilterAttributes>> = {
  importProcessId: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  code: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  name: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  status: {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "options",
  },
  message: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
};

export const FILTER_OPTION_VALUES = (
  messages: ImportationDetailsFiltersMessages
): Partial<Record<ImportationDetailsFilterKey, SelectData<FilterValue>[]>> => ({
  status: [
    { value: ImportationDetailsStatus.CREATED, label: messages.createdOption },
    { value: ImportationDetailsStatus.UPDATED, label: messages.updatedOption },
    { value: ImportationDetailsStatus.WARNING, label: messages.warningOption },
    { value: ImportationDetailsStatus.ERROR, label: messages.errorOption },
  ],
});

export const getInitialFilterValues = (importProcessId: string): IFilter<IImportationDetails>[] => [
  {
    property: "importProcessId",
    value: importProcessId,
    filterType: FilterType.Equals,
  },
];

export const initialFilterValues: IFilter<IImportationDetails>[] = [
  {
    property: "importProcessId",
    value: "",
    filterType: FilterType.Contains,
  },
];
